import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Select } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { BusinessStatus } from '../../store/entities';

@Component({
  selector: 'mwo-sync-spinner',
  templateUrl: './sync-spinner.component.html',
  styleUrls: ['./sync-spinner.component.scss']
})
export class SyncSpinnerComponent implements OnInit {
  @Select(['player', 'businessStatus']) status$: Observable<BusinessStatus>;
  diameter = 130;
  radius = this.diameter / 2;
  circumference = 2 * Math.PI * this.radius;
  value = 0;
  syncing = false;
  downloading = false;
  error = false;
  ended = false;

  constructor(
    private dialogRef: MatDialogRef<SyncSpinnerComponent>,
  ) {}

  get offset() {
    return this.circumference - (this.value / 100) * this.circumference;
  }

  ngOnInit() {
    this.status$.subscribe((status) => {
      if (!status) {
        return;
      }

      this.checkStatus(status);

      if (this.syncing && status.syncStatus?.maxValue !== 0) {
        this.value = (status.syncStatus?.currentValue / status.syncStatus?.maxValue) * 100 > 100
          ? 100
          : (status.syncStatus?.currentValue / status.syncStatus?.maxValue) * 100;
      }

      if (this.downloading && status?.downloadStatus.maxValue !== 0) {
        this.value = (status.downloadStatus?.currentValue / status.downloadStatus?.maxValue) * 100 > 100
          ? 100
          : (status.downloadStatus?.currentValue / status.downloadStatus?.maxValue) * 100;
      }

      this.checkIfProcessEnded(status);
      this.closeSyncSpinnerDialog();
    });
  }

  checkStatus(status: BusinessStatus): void {
    if (!status.syncStatus) {
      console.error('Sync status is not defined');
      return;
    }

    if (!status.downloadStatus) {
      console.error('Download status is not defined');
      return;
    }

    switch (status.syncStatus.type) {
      case 'SYNCING':
        this.syncing = true;
        break;
      case 'FINISHED':
        this.syncing = false;
        break;
      case 'ERROR':
        this.error = true;
        break;
      case 'OFFLINE':
        this.syncing = false;
        this.error = false;
        break;
      default:
        this.syncing = false;
        break;
    }

    switch (status?.downloadStatus.type) {
      case 'DOWNLOADING':
        this.downloading = true;
        break;
      case 'FINISHED':
        this.downloading = false;
        break;
      case 'ERROR':
        this.error = true;
        break;
      default:
        this.downloading = false;
        break;
    }
  }

  closeSyncSpinnerDialog(): void {
    if (this.ended) {
      setTimeout(() => {
        this.dialogRef.close(); // Close the dialog after 4 seconds
      }, 2000);
    }
  }

  private checkIfProcessEnded(status: BusinessStatus) {
    if ((status.syncStatus.type === 'FINISHED' || status.syncStatus.type === 'OFFLINE')
      && status.downloadStatus.type === 'FINISHED') {
      this.ended = true;
      this.value = 100;
    }
  }
}
